import { Input } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';

interface FormFieldHiddenProps {
    field: FormFieldDto;
    defaultValue?: string;
}

export function FormFieldHidden({ field, defaultValue }: FormFieldHiddenProps) {
    return <Input name={field.name} type="hidden" defaultValue={defaultValue ?? field.options?.defaultValue} />;
}
